import { Modal } from "antd";
import { CustomModalProps } from "../../types/index.type";

export default function CustomModal({
  title = "",
  open,
  centered = true,
  className = "",
  disableCloseButton = false,
  handleClose,
  children,
  ...rest
}: CustomModalProps) {
  return (
    <Modal
      title={title}
      open={open}
      centered={centered}
      className={`custom-modal ${className}`}
      onCancel={() => !disableCloseButton && handleClose()}
      // footer={null}
      {...rest}
    >
      {children}
    </Modal>
  );
}
